import React, { Component } from 'react'
import Gallery from 'react-grid-gallery'
import {
  Segment,
  Container
} from 'semantic-ui-react'

const IMAGES_STRESNA_OKNA =
[{
  src: 'gallery/stresnaOkna/velike/okna0.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna0.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna1.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna2.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna3.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna3.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna4.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna4.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna5.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna5.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna6.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna6.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna7.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna7.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna6-1.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna6-1.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna9.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna9.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna10-el.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna10-el.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna11-el.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna11-el.jpg',
  caption: 'Montaža strešnih oken in senčil'
},
{
  src: 'gallery/stresnaOkna/velike/okna12-el.jpg',
  thumbnail: 'gallery/stresnaOkna/velike/okna12-el.jpg',
  caption: 'Montaža strešnih oken in senčil'
}
]

const IMAGES_STROPI =
[{
  src: 'gallery/stropi/velike/strop1.jpg',
  thumbnail: 'gallery/stropi/velike/strop1.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop2.jpg',
  thumbnail: 'gallery/stropi/velike/strop2.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop3.jpg',
  thumbnail: 'gallery/stropi/velike/strop3.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop4.jpg',
  thumbnail: 'gallery/stropi/velike/strop4.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop5.jpg',
  thumbnail: 'gallery/stropi/velike/strop5.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop6.jpg',
  thumbnail: 'gallery/stropi/velike/strop6.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop7.jpg',
  thumbnail: 'gallery/stropi/velike/strop7.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop8.jpg',
  thumbnail: 'gallery/stropi/velike/strop8.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop9.jpg',
  thumbnail: 'gallery/stropi/velike/strop9.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop10.jpg',
  thumbnail: 'gallery/stropi/velike/strop10.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop11.jpg',
  thumbnail: 'gallery/stropi/velike/strop11.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop12.jpg',
  thumbnail: 'gallery/stropi/velike/strop12.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop13.jpg',
  thumbnail: 'gallery/stropi/velike/strop13.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop14.jpg',
  thumbnail: 'gallery/stropi/velike/strop14.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop15.jpg',
  thumbnail: 'gallery/stropi/velike/strop15.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop16.jpg',
  thumbnail: 'gallery/stropi/velike/strop16.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
},
{
  src: 'gallery/stropi/velike/strop17.jpg',
  thumbnail: 'gallery/stropi/velike/strop17.jpg',
  caption: 'Izdelava armstrong stropov in stropov po sistemu knauf'
}
]

const IMAGES_PLESKARSKA_DELA =
[{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela1.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela1.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 130,
  thumbnailHeight: 98
},
{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela2.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela2.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 130,
  thumbnailHeight: 98
},
{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela3.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela3.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 130,
  thumbnailHeight: 98
},
{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela4.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela4.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 130,
  thumbnailHeight: 98
},
{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela5.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela5.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 130,
  thumbnailHeight: 98
},
{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela7.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela7.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 130,
  thumbnailHeight: 98
},
{
  src: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela8.jpg',
  thumbnail: 'gallery/slikopleskarskaDela/velike/slikopleskarska_dela8.jpg',
  caption: 'Slikopleskarska dela',
  thumbnailWidth: 72,
  thumbnailHeight: 54
}]

const IMAGES_FASADE =
[{
  src: 'gallery/fasade/velike/fasade1.jpg',
  thumbnail: 'gallery/fasade/velike/fasade1.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade2.jpg',
  thumbnail: 'gallery/fasade/velike/fasade2.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade3.jpg',
  thumbnail: 'gallery/fasade/velike/fasade3.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade4.jpg',
  thumbnail: 'gallery/fasade/velike/fasade4.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade5.jpg',
  thumbnail: 'gallery/fasade/velike/fasade5.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade6.jpg',
  thumbnail: 'gallery/fasade/velike/fasade6.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade7.jpg',
  thumbnail: 'gallery/fasade/velike/fasade7.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade8.jpg',
  thumbnail: 'gallery/fasade/velike/fasade8.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade9.jpg',
  thumbnail: 'gallery/fasade/velike/fasade9.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade10.jpg',
  thumbnail: 'gallery/fasade/velike/fasade10.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade11.jpg',
  thumbnail: 'gallery/fasade/velike/fasade11.jpg',
  caption: 'Fasaderska in štukaderska dela'
},
{
  src: 'gallery/fasade/velike/fasade12.jpg',
  thumbnail: 'gallery/fasade/velike/fasade12.jpg',
  caption: 'Fasaderska in štukaderska dela'
}]

const IMAGES_PODSTRESNA_STANOVANJA =
[{
  src: 'gallery/stanovanja/velike/1.jpg',
  thumbnail: 'gallery/stanovanja/velike/1.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/2.jpg',
  thumbnail: 'gallery/stanovanja/velike/2.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/3.jpg',
  thumbnail: 'gallery/stanovanja/velike/3.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/4.jpg',
  thumbnail: 'gallery/stanovanja/velike/4.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/5.jpg',
  thumbnail: 'gallery/stanovanja/velike/5.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/6.jpg',
  thumbnail: 'gallery/stanovanja/velike/6.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/7.jpg',
  thumbnail: 'gallery/stanovanja/velike/7.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/8.jpg',
  thumbnail: 'gallery/stanovanja/velike/8.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/9.jpg',
  thumbnail: 'gallery/stanovanja/velike/9.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/10.jpg',
  thumbnail: 'gallery/stanovanja/velike/10.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/11.jpg',
  thumbnail: 'gallery/stanovanja/velike/11.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/12.jpg',
  thumbnail: 'gallery/stanovanja/velike/12.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/13.jpg',
  thumbnail: 'gallery/stanovanja/velike/13.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/14.jpg',
  thumbnail: 'gallery/stanovanja/velike/14.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/15.jpg',
  thumbnail: 'gallery/stanovanja/velike/15.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/16.jpg',
  thumbnail: 'gallery/stanovanja/velike/16.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/17.jpg',
  thumbnail: 'gallery/stanovanja/velike/17.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/18.jpg',
  thumbnail: 'gallery/stanovanja/velike/18.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/19.jpg',
  thumbnail: 'gallery/stanovanja/velike/19.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/20.jpg',
  thumbnail: 'gallery/stanovanja/velike/20.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/21.jpg',
  thumbnail: 'gallery/stanovanja/velike/12.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/22.jpg',
  thumbnail: 'gallery/stanovanja/velike/22.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/23.jpg',
  thumbnail: 'gallery/stanovanja/velike/23.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/24.jpg',
  thumbnail: 'gallery/stanovanja/velike/24.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/25.jpg',
  thumbnail: 'gallery/stanovanja/velike/25.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/26.jpg',
  thumbnail: 'gallery/stanovanja/velike/26.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/27.jpg',
  thumbnail: 'gallery/stanovanja/velike/27.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/28.jpg',
  thumbnail: 'gallery/stanovanja/velike/28.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/29.jpg',
  thumbnail: 'gallery/stanovanja/velike/29.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/30.jpg',
  thumbnail: 'gallery/stanovanja/velike/30.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/31.jpg',
  thumbnail: 'gallery/stanovanja/velike/31.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/32.jpg',
  thumbnail: 'gallery/stanovanja/velike/32.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/33.jpg',
  thumbnail: 'gallery/stanovanja/velike/33.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/34.jpg',
  thumbnail: 'gallery/stanovanja/velike/34.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/35.jpg',
  thumbnail: 'gallery/stanovanja/velike/35.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/36.jpg',
  thumbnail: 'gallery/stanovanja/velike/36.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/37.jpg',
  thumbnail: 'gallery/stanovanja/velike/37.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/38.jpg',
  thumbnail: 'gallery/stanovanja/velike/38.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/39.jpg',
  thumbnail: 'gallery/stanovanja/velike/39.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/40.jpg',
  thumbnail: 'gallery/stanovanja/velike/40.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/41.jpg',
  thumbnail: 'gallery/stanovanja/velike/41.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/42.jpg',
  thumbnail: 'gallery/stanovanja/velike/42.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/43.jpg',
  thumbnail: 'gallery/stanovanja/velike/43.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/44.jpg',
  thumbnail: 'gallery/stanovanja/velike/44.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/45.jpg',
  thumbnail: 'gallery/stanovanja/velike/45.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/46.jpg',
  thumbnail: 'gallery/stanovanja/velike/46.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/47.jpg',
  thumbnail: 'gallery/stanovanja/velike/47.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/48.jpg',
  thumbnail: 'gallery/stanovanja/velike/48.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/49.jpg',
  thumbnail: 'gallery/stanovanja/velike/49.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/50.jpg',
  thumbnail: 'gallery/stanovanja/velike/50.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/51.jpg',
  thumbnail: 'gallery/stanovanja/velike/51.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/52.jpg',
  thumbnail: 'gallery/stanovanja/velike/52.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/53.jpg',
  thumbnail: 'gallery/stanovanja/velike/53.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/54.jpg',
  thumbnail: 'gallery/stanovanja/velike/54.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/55.jpg',
  thumbnail: 'gallery/stanovanja/velike/55.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/56.jpg',
  thumbnail: 'gallery/stanovanja/velike/56.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/57.jpg',
  thumbnail: 'gallery/stanovanja/velike/57.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/58.jpg',
  thumbnail: 'gallery/stanovanja/velike/58.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/59.jpg',
  thumbnail: 'gallery/stanovanja/velike/59.jpg',
  caption: 'Izdelava podstrešnih stanovanj'
},
{
  src: 'gallery/stanovanja/velike/60.jpg',
  thumbnail: 'gallery/stanovanja/velike/60.jpg',
  caption: 'Izdelava podstrešnih stanovanj',
  thumbnailWidth: 72,
  thumbnailHeight: 54
},
{
  src: 'gallery/stanovanja/velike/61.jpg',
  thumbnail: 'gallery/stanovanja/velike/61.jpg',
  caption: 'Izdelava podstrešnih stanovanj',
  thumbnailWidth: 72,
  thumbnailHeight: 54
}]


class Galerija extends Component {
  constructor(props) {
    super(props)
    this.state = { selectedCategory: 'All' }
  }

  render() {
    return (
      <div>
        <Segment basic>
          <Container>
            <h3 id="category-title">Galerija slik</h3>
            <h3>Montaža strešnih oken in senčil</h3>
            <div style={{display: 'block', minHeight: '1px', width: '100%', overflow: 'auto'}}>
              <Gallery images={IMAGES_STRESNA_OKNA} enableImageSelection={false} />
            </div>

            <h3>Izdelava armstrong stropov in stropov po sistemu knauf</h3>
            <div style={{display: 'block', minHeight: '1px', width: '100%', overflow: 'auto'}}>
              <Gallery images={IMAGES_STROPI} enableImageSelection={false} />
            </div>
            <h3>Pleskarska dela</h3>
            <div style={{display: 'block', minHeight: '1px', width: '100%', overflow: 'auto'}}>
              <Gallery images={IMAGES_PLESKARSKA_DELA} enableImageSelection={false} />
            </div>
            <h3>Fasaderska in štukaderska dela</h3>
            <div style={{display: 'block', minHeight: '1px', width: '100%', overflow: 'auto'}}>
              <Gallery images={IMAGES_FASADE} enableImageSelection={false} />
            </div>
            <h3>Izdelava podstrešnih stanovanj (suhomontažne obloge, stropi in predelne stene po sistemu knauf)</h3>
            <div style={{display: 'block', minHeight: '1px', width: '100%', overflow: 'auto'}}>
              <Gallery images={IMAGES_PODSTRESNA_STANOVANJA} enableImageSelection={false} />
            </div>
          </Container>
        </Segment>
      </div>
    )
  }
}

export default Galerija



// WEBPACK FOOTER //
// ./src/pages/galerija/Galerija.js